import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    const run = async () => {
      if (!code) {
        navigate("/");
        return;
      }
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const res = await api.post("/auth/google", { code, redirect_uri: redirectUri });
        if (res.data.session_token) localStorage.setItem("session_token", res.data.session_token);
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF9F6]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full border-2 border-[#C07761] border-t-transparent animate-spin" />
        <p className="text-[#757169] font-heading">Connexion en cours…</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
